import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';
import { APP_META } from '../../../../services/config';
import { openUrl } from '../../../../utils/navigation';

export const WalletSelectorFooter = () => {
  const intl = useIntl();

  if (!APP_META.docsUrl) return null;

  return (
    <div className="flex items-center pt-5 justify-center text-xs">
      <span className="text-xs">
        <FormattedMessage
          id="first_time_using_ref"
          defaultMessage="First time using {appName}"
          values={{ appName: APP_META.name }}
        />
        ?
      </span>
      <div
        className="ml-2 cursor-pointer hover:underline font-bold"
        onClick={() => {
          openUrl(APP_META.docsUrl);
        }}
        style={{
          textDecorationThickness: '0.5px',
        }}
      >
        {intl.formatMessage({
          id: 'learn_more',
          defaultMessage: 'Learn more',
        })}
      </div>
    </div>
  );
};
